import { Pipe, PipeTransform } from '@angular/core';
import { QuestionType } from '@features/opportunities/components/questionnaire-form/models/questionnaire';

@Pipe({
  name: 'isMultipleChoice',
  pure: true
})
export class IsMultipleChoicePipe implements PipeTransform {
  transform(questionType: QuestionType): boolean {
    return questionType === 'Multiple Choice';
  }
}
